// extracted by mini-css-extract-plugin
export var imagePreview = "index-module--imagePreview--0BxCu";
export var overlay = "index-module--overlay--aZocV";
export var tip = "index-module--tip--bBWER";